module.exports = __webpack_public_path__ + "static-portal/img/44.42c2753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/44.jpg
// module id = iaFz
// module chunks = 4